// @flow
import * as React from 'react'

import * as session from '../lib/session'
import { context } from '../lib/context'

export default function useSession() {
  const [hasSession, setHasSession] = React.useContext(context)

  return [
    hasSession,
    {
      create(userId: number) {
        session.create(userId)
        setHasSession(true)
      },
      destroy() {
        session.destroy()
        setHasSession(false)
      },
    },
  ]
}
